import React from "react";
import ReactDOM from "react-dom";
import AccessRelationControl, { IProps } from "../../common/controls/AccessRelationControl";
import { IConfig, IFieldsConfig } from "../../common/controls/RelationAccesses/IModels";
import { stringToIssue } from "../../common/controls/Relations/IssueForRelations";
import { WorkflowContext } from "../ajaxWorkflowModal/WorkflowContext";

function stringToObject(value: string) {
	if (!value)
		return undefined;
	
	return JSON.parse(value);
}

export default function(control: HTMLElement, i: number) {

	var config = JSON.parse(control.dataset.config) as IConfig;
	var defaults: IFieldsConfig = {
		employee: {
			hidden: false,
			multiple: false,
			maxRows: 20,
		},
		application: {
			hidden: false,
			multiple: false,
			maxRows: 20,
		},
		service: {
			hidden: true,
			multiple: false,
			maxRows: 20,
		},
		dateFrom: {
			columnHidden: false,
			hidden: false,
			required: false,
		},
		dateTo: {
			columnHidden: false,
			hidden: false,
			required: false,
		},
		description: {
			columnHidden: false,
			hidden: false,
			required: false,
		},
		environment: {
			columnHidden: true,
			hidden: true,
			required: false,
			type: 'text',
		},
		login: {
			columnHidden: false,
			hidden: false,
			required: false,
			showLoginGenerator: false,
		},
		password: {
			columnHidden: true,
			hidden: true,
			required: false,
		},
		referenceNumber: {
			columnHidden: true,
			hidden: true,
			required: false,
		},
		personAccountDescription: {
			columnHidden: true,
			hidden: true,
			required: false,
		},
		personAccountType: {
			columnHidden: true,
			hidden: true,
			required: false,
		},
		company: {
			columnHidden: true,
			hidden: true,
			required: false,
		},
		telephone: {
			columnHidden: true,
			hidden: true,
			required: false,
		},
		email: {
			columnHidden: true,
			hidden: true,
			required: false,
		},
		location: {
			columnHidden: true,
			hidden: true,
			required: false,
		},

		permissionRole: {
			columnHidden: false,
			hidden: false,
			required: false,
			maxRows: 20,
		},
		systemName: {
			columnHidden: true,
			hidden: true,
			required: false,
		},
	}
	for (var p in defaults) {
		if (!config.fields[p])
			config.fields[p] = defaults[p];
	}

	return ReactDOM.createPortal(
		<WorkflowAccessResourceRelationsData
			key={"react-access-resource-relations-data-" + i}
			issue={stringToIssue(control.dataset.issue)}

			name={control.dataset.name}
			value={control.dataset.value}

			defaultEmployee={control.dataset.defaultEmployee}
			defaultApplications={control.dataset.defaultApplications}
			defaultServices={control.dataset.defaultServices}

			editCurrentEmployee={control.dataset.editCurrentEmployee === "True"}

			blockInsert={control.dataset.blockInsert === "True"}
			blockEditRows={control.dataset.blockEditRows === "True"}
			blockCloneRows={control.dataset.blockCloneRows === "True"}
			blockDeleteRows={control.dataset.blockDeleteRows === "True"}

			forAcceptant={control.dataset.forAcceptant === "True"}
			subordinatesTree={control.dataset.subordinatesTree === "True"}
			blockChangeEmployees={control.dataset.blockChangeEmployees === "True"}

			currentAccessesHiddenInsertButton={control.dataset.currentAccessesHiddenInsertButton === "True"}
			currentAccessesHiddenEditButton={control.dataset.currentAccessesHiddenEditButton === "True"}
			currentAccessesFilterId={control.dataset.currentAccessesFilterId}
			currentAccessesTable={stringToObject(control.dataset.currentAccessesTable)}

			currentAuthorizationsButton={stringToObject(control.dataset.currentAuthorizationsButton)}

			config={config}
		/>,
	control);
};

export function WorkflowAccessResourceRelationsData(props: IProps) {
	return <WorkflowContext.Consumer>
		{({ issueWorkflowData, setIssueWorkflowData }) => (
			<AccessRelationControl {...props} onSet={(value) => {
				let data = { ...issueWorkflowData };
				data[props.name] = value;
				setIssueWorkflowData(data);
			}} />
		)}
	</WorkflowContext.Consumer>
}